import { Routes } from '@angular/router';
import { NonStandardModalEntryComponent } from '@design/modals/non-standard-modal/non-standard-modal-entry.component';
import { PensionContributionsAdvancedViewComponent } from './contributions/pension-contributions-advanced-view.component';
import { FeatureFlagEnabledRouteGuard, getFeatureFlagKey } from '@security/authorization/feature-flag-enabled.route-guard';

export const pensionConnectModalRoutes: Routes = [
  {
    path: 'pension-submissions/submissions/contributions',
    outlet: 'modal',
    component: NonStandardModalEntryComponent,
    canActivate: [FeatureFlagEnabledRouteGuard],
    data: {
      ...getFeatureFlagKey('pensionConnect'),
      componentType: PensionContributionsAdvancedViewComponent,
      modalType: 'Custom',
      panelClass: 'advanced-reports-modal-panel',
      fullScreen: true
    },
    runGuardsAndResolvers: 'always'
  }
];
